import Button from "@mui/material/Button";
import thunderstorm from './../assets/thunderstorm.png'
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
  let navigate = useNavigate()
  return (
    <div style={{ width: '100%' }}>
      <div style={{maxWidth:'400px', width:'100%', marginLeft:'auto', marginRight:'auto', textAlign:'center', marginTop:'50px'}}>
        <img src={thunderstorm} alt="thunderstorm" style={{marginLeft:'auto', marginRight:'auto', height:"50vh", width:'auto', textAlign:'center'}} />
        <Typography variant="h5" gutterBottom component="div" >
          La pagina cercata non esiste
        </Typography>
        <Button onClick={()=>navigate('/home')} variant="contained">Torna alla home</Button>
      </div>
    </div>
  )
}